import { isFieldGroup } from '@modusign/react-signing';
import { FieldNode } from '@modusign/react-signing/types';
import { DeepReadonly } from 'ts-essentials';

import calculateDuplication from '@app/libs/calculateDuplication';

type DataLabelError = 'EMPTY_VALUE' | 'DUPLICATED_VALUE';

export function getFieldsDataLabelErrors(
  fields: DeepReadonly<FieldNode[]>
): DataLabelError[] | null {
  const dataLabelMap: Record<string, string> = {};
  // eslint-disable-next-line no-restricted-syntax
  function dfs(targets: DeepReadonly<FieldNode[]>) {
    for (const field of targets) {
      dataLabelMap[field.id] = field.dataLabel.trim();

      if (isFieldGroup(field)) {
        if (field.type !== 'CHECKBOX_GROUP') {
          dfs(field.children);
        }
      }
    }
  }
  dfs(fields);

  const hasEmptyValue = Object.values(dataLabelMap).includes('');
  const isDuplicated = Object.values(calculateDuplication(dataLabelMap)).includes(true);

  const result: DataLabelError[] = [];
  if (hasEmptyValue) {
    result.push('EMPTY_VALUE');
  }

  if (isDuplicated) {
    result.push('DUPLICATED_VALUE');
  }

  return result.length > 0 ? result : null;
}
